module.exports = __webpack_public_path__ + "static/media/caseevict-white.4f3a3c16.svg";